export const environment = {
  production: false,
  apiUrl: 'https://moba-test-download-area-api.azurewebsites.net/',
  name: 'test',
  PublicKey: 'd2ViLURvd25sb2FkQXJlYUBNb2JhMjAyNQ==',
  DownloadURL: 'https://moba-test-download-area-api.azurewebsites.net/documents/',
  AllowedHosts: 'moba-portal.com'
};
